import { getAgentAdvisors } from "web_myplann/Advisor/Utils/getAgentAdvisors";
import { useAssignedAgentsQuery } from "web_myplann/Api/Advisor/useAssignedAgentsQuery";
import { UserAgentStatusEnum } from "web_myplann/Infrastructure/Api/Api";

export const useAdvisorsList = () => {
	const {
		data: connected,
		isPending: connectedPending,
		isError: connectedError,
		isRefetching: connectedRefetching,
		refetch: refetchConnected,
	} = useAssignedAgentsQuery(UserAgentStatusEnum.Connected);
	const {
		data: pending,
		isPending: pendingPending,
		refetch: refetchPending,
	} = useAssignedAgentsQuery(UserAgentStatusEnum.PendingClient);
	const isLoading = connectedPending || pendingPending;

	return {
		connectedAdvisors: getAgentAdvisors(connected?.data ?? []),
		pendingAdvisors: pending?.data ?? [],
		advisorsPending: pending?.meta?.totalCount,
		isLoading,
		isError: connectedError && !connected,
		isRefetching: connectedRefetching,
		refetch: () => Promise.all([refetchConnected(), refetchPending()]),
	};
};
